<template>
	<div class="session-list-item ui-elevation-1 panel">
		<div class="session-list-item__header">
			<i class="fa fa-stream"></i>
			<div class="ui-subheading">RTMP</div>
		</div>
		<div class="session-list-item__content">
			<dynamic-duration
				:duration="session.duration"
				class="ui-display-2"
			/>
		</div>
		<div class="session-list-item__footer">
			<div>
				<div class="ui-caption">Start time</div>
				<div>{{ session.start | date("HH:mm") }}</div>
			</div>
			<div>
				<div class="ui-caption">Client</div>
				<div>{{ session.client }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import DynamicDuration from "session/ui/DynamicDuration";

export default {
	name: "SessionItemRtmp",
	components: {
		DynamicDuration
	},
	props: {
		session: {
			type: Object,
			required: true
		}
	}
};
</script>

<style lang="scss" scoped>
.session-list-item {
	order: 3;
	.session-list-item__header {
		padding: 8px;
		i {
			color: var(--ui-theme-secondary);
			float: left;
			font-size: 24px;
			line-height: 40px;
			margin: 0 14px 0 10px;
		}
		div {
			line-height: 40px;
		}
	}
	.session-list-item__content {
		background-color: rgba(0, 0, 0, 0.12);
		height: 72px;
		.dynamic-duration {
			float: left;
			margin-top: 12px;
			margin-left: 8px;
		}
	}
	.session-list-item__footer {
		padding: 8px;
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		grid-gap: 16px;
		>div {
			place-self: center;
			text-align: center;
		}
	}
}

// IE11 specific, using flex due to poor grid support
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
	.session-list-item {
		margin: 8px;
		min-width: 312px;
		.session-list-item__footer {
			display: flex;
			justify-content: space-around;
		}
	}
	// 2 columns
	@media (min-width: 732px) {
		.session-list-item {
			max-width: 454px;
		}
	}
	// 3 columns
	@media (min-width: 1200px) {
		.session-list-item {
			max-width: 366px;
		}
	}
}
</style>
